// Utility functions for user display and information formatting
export const getInitialsFromEmail = (email) => {
  if (!email || typeof email !== 'string') return 'U';
  const namePart = email.split('@')[0];
  
  if (namePart.includes('.')) {
    const parts = namePart.split('.');
    return (parts[0].charAt(0) + (parts[1] ? parts[1].charAt(0) : '')).toUpperCase();
  } else if (namePart.includes('-')) {
    const parts = namePart.split('-');
    return (parts[0].charAt(0) + (parts[1] ? parts[1].charAt(0) : '')).toUpperCase();
  } else if (namePart.includes('_')) {
    const parts = namePart.split('_');
    return (parts[0].charAt(0) + (parts[1] ? parts[1].charAt(0) : '')).toUpperCase();
  } else {
    return namePart.substring(0, 2).toUpperCase();
  }
};

/**
 * Get display name from email 
 * Format: "name.surname@example.com" => "Name Surname"
 */
export const getDisplayNameFromEmail = (email) => {

  if (!email || typeof email !== 'string') return 'User';
  const namePart = email.split('@')[0];
  if (namePart.includes('.')) {
    return namePart.split('.')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  } else if (namePart.includes('-')) {
    return namePart.split('-')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  } else if (namePart.includes('_')) {
    return namePart.split('_')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  } else {
    return namePart.charAt(0).toUpperCase() + namePart.slice(1);
  }
};
